<template>
  <div id="Ajuda">
    <b-container>
      <h3 class="restam-duvidas">
        Estamos sempre
        <br /> prontos para ajudar
      </h3>
      <p class="descricao">
       {{ description }}
        <br /> Contrate agora, fique bem mais protegido.
      </p>
      <b-row>
        <b-col sm="5" class="informacoes">
          <p>Em qualquer cidade do país, ligue:</p>
          <a href="tel:08000244386">
            <h3>0800 024 4386</h3>
          </a>

          <p>Dúvidas e televendas:</p>
          <a href="tel:08007292038">
            <h3>0800 729 2038</h3>
          </a>

          <p>E-mail</p>
          <a href="mailto:falecom@ciclic.com.br" target="_blank">
            <h3>falecom@ciclic.com.br</h3>
          </a>
        </b-col>
        <b-col sm="6"></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import './Ajuda.css'

export default {
  name: 'Ajuda',
  computed: {
    description () {
      return process.env.VUE_APP_PRODUCT_NAME === 'seguro-equipamentos-portateis'
        ? 'Com o Seguro Eletrônico Ciclic o seu aparelho fica seguro.'
        : 'Oferecemos a proteção que o seu celular precisa.'
    }
  }
}
</script>
